import { ListPickerControlModalItemModel } from "../list-picker-control-modal-item.model";
import { Observable } from "rxjs/Observable";
import { BaseObject } from "../../../../../core/business-objects/base-object/base-object.model";
import { IBaseObjectFacade } from "../../../../../core/store/facade/i-base-object.facade";
import { IListProvider } from "./list-provider.interface";
import { VasAppFacade } from "../../../../services/vas-app-facade.service";

export abstract class ListProvider<T extends BaseObject> implements IListProvider {

    constructor(protected appFacade: VasAppFacade) {

    }

    protected abstract getFacade(): IBaseObjectFacade<T>;

    abstract getPrimaryField(item: T): string;

    getSecondaryField(item: T): string {
        return "";
    }

    getItem(id: string): T {
        let item: T;
        this.getFacade().get(id).take(1).subscribe(_item => item = _item);
        return item;
    }

    getList(...parameters): Observable<Array<ListPickerControlModalItemModel>> {
        return this.getFacade()
            .getAll()
            .map(items => items.map(item => new ListPickerControlModalItemModel(item.id, this.getPrimaryField(item))));
    }

    getDisplayValue(id: string): string {
        if (!id) return "";
        const item = this.getItem(id);
        return item ? this.getPrimaryField(item) : "";
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/list-provider.ts